import React, { useState } from 'react';
import { DatePicker } from 'antd';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/fr_FR';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/fr';
import './datepicker.css';
import dateInputSuffix from './dateInputSuffix.svg';
import { FieldError } from 'react-hook-form';
type DateInputProps = {
    onChange: (value: string) => void;
    value: string;
    label: string;
    required: boolean;
    error?: FieldError;
    disabled: boolean;
    width?: string;
    labelWidth?: string;
    disabledDate?: (current: Dayjs) => boolean;
};

const DateInput = ({
    onChange,
    value,
    label,
    required,
    error,
    disabled,
    width = '',
    labelWidth = 'w-36',
    disabledDate
}: DateInputProps) => {
    const [localValue, setLocalValue] = useState<Dayjs | null>(null);

    const handleChange = (date: Dayjs | null) => {
        if (date) {
            setLocalValue(date);
            onChange(date.format('YYYY-MM-DD'));
        }
        else {
            setLocalValue(null);
        }
    };

    return (
        <div className="flex flex-col">
            <div className="flex flex-row items-center justify-between w-full">
                <div className={`flex flex-row ${labelWidth}`}>
                    <label className="font-normal text-sm text-[#646464]">{label}
                        {required && <span className="ml-1 text-sm font-normal text-red-500">*</span>}
                    </label>
                </div>
                <ConfigProvider locale={locale}>
                    <DatePicker
                        getPopupContainer={(trigger) => trigger.parentElement!}
                        className={`dateInput ${width}`}
                        value={value === 'Invalid Date' || value === null || value === undefined ? null : localValue ? localValue : dayjs(value, 'DD/MM/YYYY')}
                        defaultValue={null}
                        onChange={handleChange}
                        format="DD/MM/YYYY"
                        disabled={disabled}
                        disabledDate={disabledDate}
                        suffixIcon={<img src={dateInputSuffix} alt="icon"/>}
                    />
                </ConfigProvider>
            </div>
            {error && <div className="text-xs italic text-red-500">{error.message}</div>}
        </div>
    );
};

export default DateInput;
